var $de104bf355206bcf$exports = {};
$de104bf355206bcf$exports = {
  "breadcrumbs": "Putanje navigacije"
};
export { $de104bf355206bcf$exports as default };